import { error } from 'react-notification-system-redux';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getAuthProps } from '@topconagriculture/auth';
import { useDashboardAPI } from './useDashboardContext';
import { notificationsConfig } from '../config/constants';
export const useWidgetsMutation = () => {
    const api = useDashboardAPI();
    const client = useQueryClient();
    const dispatch = useDispatch();
    const auth = useSelector(getAuthProps);
    return useMutation({
        mutationFn: (widgetList) => api.widget.updateWidgetList(auth.userId, widgetList),
        onSuccess: () => {
            client.invalidateQueries({ queryKey: ['widgets'] });
        },
        onError: () => {
            dispatch(error({
                ...notificationsConfig.defaultConf,
                translationKey: 'widget:widget:cant_update_widgets',
            }));
        },
    });
};
//# sourceMappingURL=useWidgetsMutation.js.map